import { Link, useLocation } from "react-router-dom";
import { InstaPassLogo } from "../layout/Components/InstaPassLogo";
import { WorkspaceSwitcher } from "../Home/MarketplaceNewUI/qrStudio/WorkspaceSwitcher";
import {
  ORGANIZER_MARKETPLACE_LINK,
  ORGANIZER_NAV_SECTIONS,
  getOrganizerActiveTab,
  isOrganizerNavActive,
} from "./organizerNavConfig";

export default function OrganizerSidebar() {
  const location = useLocation();
  const activeTab = getOrganizerActiveTab(location.search);
  const MarketplaceIcon = ORGANIZER_MARKETPLACE_LINK.icon;

  return (
    <aside
      className="hidden lg:flex fixed left-0 top-0 h-screen w-[260px] bg-[#060D1B] border-r border-[#1E293B]/60 flex-col z-30"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <div className="px-5 h-[64px] flex items-center justify-between border-b border-[#1E293B]/60">
        <Link to="/" className="flex items-center gap-2.5 min-w-0">
          <InstaPassLogo size="sm" />
          <div className="flex flex-col">
            <span className="text-[11px] text-white/70" style={{ fontWeight: 600 }}>
              Organizer
            </span>
            <span
              className="text-[9px] text-blue-400/60 uppercase tracking-[0.12em]"
              style={{ fontWeight: 700 }}
            >
              Portal
            </span>
          </div>
        </Link>
        <WorkspaceSwitcher compact />
      </div>

      <nav className="flex-1 py-4 px-3 overflow-y-auto">
        {ORGANIZER_NAV_SECTIONS.map((section) => (
          <div key={section.title} className="mb-5">
            <div className="px-3 mb-2">
              <span
                className="text-[9px] text-white/20 uppercase tracking-[0.18em]"
                style={{ fontWeight: 700 }}
              >
                {section.title}
              </span>
            </div>
            <div className="space-y-0.5">
              {section.items.map((item) => {
                const Icon = item.icon;
                const active = isOrganizerNavActive(item, location, activeTab);
                return (
                  <Link
                    key={`${section.title}-${item.label}`}
                    to={item.href}
                    className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13px] transition-all duration-200 ${
                      active
                        ? "text-white bg-blue-500/[0.12] border border-blue-500/[0.15]"
                        : "text-white/45 hover:text-white hover:bg-white/[0.03] border border-transparent"
                    }`}
                  >
                    <Icon className={`w-[16px] h-[16px] ${active ? "text-blue-400" : ""}`} strokeWidth={1.8} />
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      <div className="px-3 py-3 border-t border-[#1E293B]/60">
        <Link
          to={ORGANIZER_MARKETPLACE_LINK.href}
          className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-[12px] text-white/25 hover:text-white/50 hover:bg-white/[0.03] transition-all"
        >
          <MarketplaceIcon className="w-4 h-4" strokeWidth={1.8} />
          {ORGANIZER_MARKETPLACE_LINK.label}
        </Link>
      </div>
    </aside>
  );
}
